import { getKbConfig } from "@/features/branding";
import { Tool } from "@/types/tools";
import LineChartOutlined from "@ant-design/icons/es/icons/LineChartOutlined";
import { useRouter } from "next/router";
import { useEffect } from "react";
const buildSidebarRedirect = (): string => {
  return getKbConfig().modelling.publicDocsUrl || "/modelling/_";
};
const Render = () => {
  const router = useRouter();
  useEffect(() => {
    router.replace(buildSidebarRedirect());
  }, []);
  return <></>;
};
export default {
  id: "modelling",
  category: "reference",
  keyPrefix: "reference.modelling",
  icon: <LineChartOutlined />,
  render: () => <Render />,
  buildSidebarRedirect
} as Tool;